/* FNDRY — header */
(function () {
  'use strict';

  var HOVER = window.matchMedia('(hover: hover) and (pointer: fine)');
  var DESKTOP = window.matchMedia('(min-width: 990px)');

  function FndryHeader(root) {
    this.root = root;
    this.bar = root.querySelector('[data-header-bar]');
    this.panels = Array.prototype.slice.call(root.querySelectorAll('[data-panel]'));
    this.triggers = Array.prototype.slice.call(root.querySelectorAll('[data-panel-trigger]'));
    this.scrim = document.querySelector('[data-header-scrim]');
    this.drawer = document.querySelector('[data-header-drawer]');
    this.hero = document.querySelector('[data-fndry-hero]');
    /* The sticky rail — this section's own wrapper. It is never transformed,
       so its rect is the header's true position whatever the bar above it and
       the hide-on-scroll transform are doing. */
    this.rail = root.closest('.shopify-section') || root.parentElement;
    this.announcement = document.querySelector('[data-fndry-announcement]');

    this.openPanel = null;
    this.drawerOpen = false;
    this.lastY = window.scrollY;
    this.ticking = false;
    this.hoverTimer = null;
    this.closeTimer = null;

    this.stickyEnabled = root.dataset.sticky !== 'false';
    this.transparentEnabled = root.dataset.transparent !== 'false' && !!this.hero;

    this.bindPanels();
    this.bindDrawer();
    this.bindScroll();
    this.onScroll(true);
  }

  /* ---------- Panels (mega / science / search) ---------- */
  FndryHeader.prototype.bindPanels = function () {
    var self = this;

    this.triggers.forEach(function (trigger) {
      var name = trigger.dataset.panelTrigger;
      var item = trigger.closest('[data-nav-item]') || trigger;

      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        if (self.openPanel === name) self.close();
        else self.open(name);
      });

      if (name === 'search') return;

      item.addEventListener('mouseenter', function () {
        if (!HOVER.matches || !DESKTOP.matches) return;
        window.clearTimeout(self.closeTimer);
        self.hoverTimer = window.setTimeout(function () { self.open(name); }, 90);
      });
      item.addEventListener('mouseleave', function () {
        window.clearTimeout(self.hoverTimer);
      });
    });

    this.root.addEventListener('mouseleave', function () {
      if (!HOVER.matches || !DESKTOP.matches) return;
      window.clearTimeout(self.hoverTimer);
      self.closeTimer = window.setTimeout(function () { self.close(); }, 220);
    });
    this.root.addEventListener('mouseenter', function () {
      window.clearTimeout(self.closeTimer);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (self.drawerOpen) self.closeDrawer();
      else if (self.openPanel) self.close(true);
    });

    this.root.addEventListener('focusout', function () {
      window.setTimeout(function () {
        if (self.openPanel && !self.root.contains(document.activeElement)) self.close();
      }, 0);
    });

    if (this.scrim) {
      this.scrim.addEventListener('click', function () {
        if (self.drawerOpen) self.closeDrawer();
        self.close();
      });
    }
  };

  FndryHeader.prototype.open = function (name) {
    var self = this;
    var panel = this.panels.filter(function (p) { return p.dataset.panel === name; })[0];
    if (!panel) return;

    this.panels.forEach(function (p) { p.classList.toggle('is-open', p === panel); });
    this.triggers.forEach(function (t) {
      var on = t.dataset.panelTrigger === name;
      t.setAttribute('aria-expanded', on ? 'true' : 'false');
      var item = t.closest('[data-nav-item]');
      if (item) item.classList.toggle('is-active', on);
    });

    this.openPanel = name;
    this.root.classList.add('is-panel-open', 'is-solid');
    this.root.classList.remove('is-hidden');
    if (this.scrim && name !== 'search') this.scrim.classList.add('is-visible');

    if (name === 'search') {
      window.setTimeout(function () {
        var input = panel.querySelector('input[type="search"]');
        if (input) input.focus();
      }, 120);
    }
  };

  FndryHeader.prototype.close = function (returnFocus) {
    if (!this.openPanel) return;
    var name = this.openPanel;
    this.openPanel = null;
    this.root.classList.remove('is-panel-open');
    this.panels.forEach(function (p) { p.classList.remove('is-open'); });
    this.triggers.forEach(function (t) {
      t.setAttribute('aria-expanded', 'false');
      var item = t.closest('[data-nav-item]');
      if (item) item.classList.remove('is-active');
    });
    if (this.scrim && !this.drawerOpen) this.scrim.classList.remove('is-visible');
    this.onScroll(true);

    if (returnFocus) {
      var trigger = this.triggers.filter(function (t) { return t.dataset.panelTrigger === name; })[0];
      if (trigger) trigger.focus();
    }
  };

  /* ---------- Drawer ---------- */
  FndryHeader.prototype.bindDrawer = function () {
    var self = this;
    if (!this.drawer) return;

    document.querySelectorAll('[data-drawer-open]').forEach(function (btn) {
      btn.addEventListener('click', function () { self.openDrawer(); });
    });
    this.drawer.querySelectorAll('[data-drawer-close]').forEach(function (btn) {
      btn.addEventListener('click', function () { self.closeDrawer(); });
    });

    /* accordions */
    this.drawer.querySelectorAll('[data-accordion-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = document.getElementById(btn.getAttribute('aria-controls'));
        if (!target) return;
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        target.classList.toggle('is-open', !open);
      });
    });

    /* rudimentary focus containment */
    this.drawer.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var focusables = self.drawer.querySelectorAll('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])');
      if (!focusables.length) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  };

  FndryHeader.prototype.openDrawer = function () {
    if (!this.drawer) return;
    this.close();
    this.drawerOpen = true;
    this.drawer.classList.add('is-open');
    this.drawer.setAttribute('aria-hidden', 'false');
    if (this.scrim) this.scrim.classList.add('is-visible');
    document.body.classList.add('fndry-no-scroll');
    this.root.classList.remove('is-hidden');
    document.querySelectorAll('[data-drawer-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    var self = this;
    window.setTimeout(function () {
      var close = self.drawer.querySelector('[data-drawer-close]');
      if (close) close.focus();
    }, 120);
  };

  FndryHeader.prototype.closeDrawer = function () {
    if (!this.drawer) return;
    this.drawerOpen = false;
    this.drawer.classList.remove('is-open');
    this.drawer.setAttribute('aria-hidden', 'true');
    if (this.scrim && !this.openPanel) this.scrim.classList.remove('is-visible');
    document.body.classList.remove('fndry-no-scroll');
    var opener = document.querySelector('[data-drawer-open]');
    if (opener) { opener.setAttribute('aria-expanded', 'false'); opener.focus(); }
  };

  /* ---------- Scroll: transparency + show on scroll-up ---------- */
  /* P15 2026-10-23: the scroll path reads no layout. The bar's height, the
     announcement bar's bottom and the hero's bottom are measured once, and
     again only when the viewport or the hero changes size (measure()); the
     scroll frame works from scrollY alone and only writes classes. A resize -
     which on iPhones fires each time Safari's or Instagram's toolbar
     collapses or comes back - is handled in the next frame instead of inside
     the event, where it forced a full-page layout on its own. */
  FndryHeader.prototype.bindScroll = function () {
    var self = this;
    this.measure();

    window.addEventListener('scroll', function () {
      if (self.ticking) return;
      self.ticking = true;
      window.requestAnimationFrame(function () {
        self.onScroll();
        self.ticking = false;
      });
    }, { passive: true });

    var resizeFrame = 0;
    function remeasure() {
      if (resizeFrame) return;
      resizeFrame = window.requestAnimationFrame(function () {
        resizeFrame = 0;
        self.measure();
        self.onScroll(true);
      });
    }
    window.addEventListener('resize', remeasure, { passive: true });
    window.addEventListener('load', remeasure);
    if (window.ResizeObserver) {
      var watched = new ResizeObserver(remeasure);
      if (this.hero) watched.observe(this.hero);
      if (this.announcement) watched.observe(this.announcement);
      if (this.bar) watched.observe(this.bar);
    }
  };

  FndryHeader.prototype.measure = function () {
    var y = Math.max(window.scrollY || window.pageYOffset || 0, 0);
    this.barH = this.bar ? this.bar.offsetHeight : 72;
    this.barGone = this.announcement ? this.announcement.offsetHeight : 0;
    /* In document coordinates: the announcement bar scrolls with the page,
       and the rail sits directly under it until it sticks. */
    this.annBottom = this.announcement ? this.announcement.getBoundingClientRect().bottom + y : 0;
    this.heroBottom = this.hero ? this.hero.getBoundingClientRect().bottom + y : 0;
  };

  FndryHeader.prototype.onScroll = function (force) {
    var y = Math.max(window.scrollY || window.pageYOffset || 0, 0);
    var barH = this.barH || 72;
    /* Where the header's bottom edge actually is right now. Until the
       announcement bar has scrolled away the rail sits below the viewport top,
       so a plain `y > …` test would fill the header too early. */
    var headerBottom = Math.max(this.annBottom - y, 0) + barH;
    var barGone = this.barGone || 0;

    /* fill / clear */
    var solid = true;
    if (this.transparentEnabled && this.hero) {
      solid = this.heroBottom - y <= headerBottom + 1;
    }
    if (this.openPanel || this.drawerOpen) solid = true;
    this.root.classList.toggle('is-solid', solid);

    /* sticky on scroll-up only — never hide while the bar is still on screen */
    if (this.stickyEnabled && !this.openPanel && !this.drawerOpen) {
      var delta = y - this.lastY;
      if (y <= barH + barGone) {
        this.root.classList.remove('is-hidden');
      } else if (delta > 4) {
        this.root.classList.add('is-hidden');
      } else if (delta < -4) {
        this.root.classList.remove('is-hidden');
      }
    } else if (force) {
      this.root.classList.remove('is-hidden');
    }

    if (Math.abs(y - this.lastY) > 2 || force) this.lastY = y;
  };

  /* ---------- Boot ---------- */
  function init() {
    var root = document.querySelector('[data-fndry-header]');
    if (!root) return;
    root.__fndryHeader = new FndryHeader(root);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.querySelector('[data-fndry-header]')) init();
  });
  document.addEventListener('shopify:section:unload', function () {
    document.body.classList.remove('fndry-no-scroll');
  });
})();